/**
 * @author Björn Schmitt
 * based on http://tympanus.net/Development/NotificationStyles/bar-slidetop.html
 *
 * Usage:
 *
 *  new Notification({
 *      OPTIONS...
 *  });
 *
 */
(function (window, $) {

    'use strict';

    var animationSupport = {
            animations: Modernizr.cssanimations
        },
        animationEndEvents = {
            'WebkitAnimation': 'webkitAnimationEnd',
            'OAnimation': 'oAnimationEnd',
            'msAnimation': 'MSAnimationEnd',
            'animation': 'animationend'
        },
        animationEndEvent = animationEndEvents[Modernizr.prefixed('animation')];

    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    function Notification(options) {
        this.options = extend({}, this.options);
        extend(this.options, options);
        this.init();
    }

    Notification.prototype.options = {
        wrapper: 'body',
        message: '',
        layout: 'bar',
        effect: 'slidetop',
        type: 'notice', // notice, warning, success
        ttl: 2000,
        permanent: false,
        closeButton: true,
        scrollTo: null,
        scrollOffset: 0,
        scrollDelay: 0,
        // callbacks
        onClose: function () {
            return false;
        },
        onOpen: function () {
            return false;
        }
    };

    Notification.prototype.init = function () {
        // create HTML structure
        this.ntf = $('<div/>');
        this.ntf.attr('class', 'ns-box ns-' + this.options.layout + ' ns-effect-' + this.options.effect + ' ns-type-' + this.options.type);
        var html = '<div class="ns-box-inner">';
        html += this.options.message;
        html += '</div>';
        if (this.options.closeButton || this.options.permanent) {
            html += '<span class="ns-close"></span>';
        }
        html += '</div>';
        this.ntf.html(html);

        // append to body or the element specified in options.wrapper
        $(this.options.wrapper).prepend(this.ntf);

        if (!this.options.permanent) {
            // close after [options.ttl]ms
            var self = this;
            this.closeTimer = setTimeout(function (e) {
                if (self.active) {
                    self.close(e);
                }
            }, this.options.ttl);
        }

        // init events
        this.initEvents();

        // show
        this.show();
    };

    Notification.prototype.initEvents = function () {
        var self = this;
        this.ntf.find('.ns-close').click(function (e) {
            self.close(e);
        });
    };

    Notification.prototype.show = function () {
        this.active = true;
        this.ntf.removeClass('ns-hide');
        this.ntf.addClass('ns-show');
        if (this.options.scrollTo) {
            $('html, body').delay(this.options.scrollDelay).animate({
                scrollTop: $(this.options.scrollTo).offset().top - parseInt(this.options.scrollOffset)
            }, 800);
        }
        this.options.onOpen();
    };

    Notification.prototype.close = function (e) {
        var self = this;
        this.active = false;

        // add close animation class
        clearTimeout(this.closeTimer);
        self.ntf.removeClass('ns-show');
        setTimeout(function () {
            self.ntf.addClass('ns-hide');
            self.options.onClose();
        }, 25);

        // remove after animation end
        if (animationSupport.animations) {
            $(self.ntf).on(animationEndEvent, function () {
                $(self.ntf).remove();
            });
        } else {
            $(self.ntf).remove();
        }
    };

    window.Notification = Notification;

})(window, jQuery);
